<div class="engagement-panel">
  @if (openRequestEngagementPopup) {
    <kendo-popup
      (close)="close()"
      [animate]="animate"
      [anchor]="anchor"
      [anchorAlign]="anchorAlign"
      [popupAlign]="popupAlign"
      popupClass="full-height-popup"
      [margin]="margin"
      >
      <div #popupContent class="add-client-container">
        <div class="popup-header">
          <div class="popup-title">Engagement Request</div>
          <button class="close-btn" (click)="close()">&#x2715;</button>
        </div>
        <div>
          @if (isDisplayloader) {
            <div class="setloader-position"
              >
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                size="default"
                color="#225EFF"
                type="ball-triangle-path" [fullScreen]="false">
              </ngx-spinner>
            </div>
          }
          @if (!isDisplayloader) {
            <div class="engagement-details-section">
              @if (requestEngagementRequestForm) {
                <form class="k-form k-form-md"
                  [formGroup]="requestEngagementRequestForm">
                  <div class="wrapper">
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Engagement Details</h3>
                        </div>
                      </kendo-card-header>
                      <kendo-card-body class="k-custom-card-body">
                        <div class="row">
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Status"></kendo-label>
                              <h4 class="ellipse">{{ engagementDetail.engagementStatus }} </h4>
                            </div>
                          </div>
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Number"></kendo-label>
                              <h4 class="ellipse">{{ engagementDetail.engagementNumber }}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Name"></kendo-label>
                              <div class="ellipse"
                                kendoTooltip
                                filter="h4"
                                >
                                <h4 class="ellipse" title="{{ engagementDetail.engagementName }}">
                                  {{ engagementDetail.engagementName }}
                                </h4>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Type"></kendo-label>
                              <h4 class="ellipse">{{ engagementDetail.engagementType }}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Created Date"></kendo-label>
                              <h4 class="ellipse">{{ engagementDetail.engagementCreatedDate | kendoDate: "MM/dd/yyyy" }}</h4>
                            </div>
                          </div>
                          <div class="col-6">
                            <div>
                              <kendo-label text="Engagement Close Date"></kendo-label>
                              <h4 class="ellipse">{{ engagementDetail.engagementClosedDate !== null ? (engagementDetail.engagementClosedDate | kendoDate: "MM/dd/yyyy") : '--/--/----' }}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <div>
                              <kendo-label text="Client Code"></kendo-label>
                              <h4 class="ellipse" style="margin-bottom: 0px">{{ engagementDetail.clientCode }}</h4>
                            </div>
                          </div>
                          <div class="col-6">
                            <div>
                              <kendo-label text="Client Name"></kendo-label>
                              <div class="ellipse"
                                kendoTooltip
                                filter="h4"
                                >
                                <h4 class="ellipse" style="margin-bottom: 0px" title="{{ engagementDetail.clientName }}">
                                  {{ engagementDetail.clientName }}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </kendo-card-body>
                    </kendo-card>
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Function and Service Details</h3>
                        </div>
                      </kendo-card-header>
                      <kendo-card-body class="k-custom-card-body">
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Profit Centre Code"></kendo-label>
                            <h4>
                              {{ engagementDetail.profitCenterCode }}
                            </h4>
                          </div>
                          <div class="col-6">
                            <kendo-label text="Profit Centre Description"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 class="ellipse" title="{{ engagementDetail.profitCenterDescription}}">
                                {{ engagementDetail.profitCenterDescription }}
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Offering Group Description"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 class="ellipse" title="{{ engagementDetail.serviceGroupDescription }}">
                                {{ engagementDetail.serviceGroupDescription }}
                              </h4>
                            </div>
                          </div>
                          <div class="col-6">
                            <kendo-label text="Offering Description"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 class="ellipse" title="{{ engagementDetail.serviceLineDescription }}">
                                {{ engagementDetail.serviceLineDescription }}
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Line of Business"></kendo-label>
                            <h4 style="margin-bottom: 0px" class="ellipse">
                              {{ engagementDetail.lineOfBusiness }}
                            </h4>
                          </div>
                        </div>
                      </kendo-card-body>
                    </kendo-card>
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Contacts</h3>
                        </div>
                      </kendo-card-header>
                      <kendo-card-body class="k-custom-card-body">
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Engagement Partner"></kendo-label>
                            <h4 class="ellipse">{{ engagementDetail.engagementPartnerName }}</h4>
                          </div>
                          <div class="col-6">
                            <kendo-label text="Engagement Partner Email Address"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 style="color: #00338d" class="ellipse" title="{{ engagementDetail.engagementPartnerEmailAddress  }}">
                                <a href="mailto:{{ engagementDetail.engagementPartnerEmailAddress }}"
                                  style="color: #00338d; text-decoration: none;">
                                  {{ engagementDetail.engagementPartnerEmailAddress }}
                                </a>
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <kendo-label text="Engagement Manager"></kendo-label>
                            <h4 style="margin-bottom: 0px" class="ellipse">{{ engagementDetail.engagementManagerName }}</h4>
                          </div>
                          <div class="col-6">
                            <kendo-label text="Manager Email"></kendo-label>
                            <div class="ellipse"
                              kendoTooltip
                              filter="h4"
                              >
                              <h4 style="color: #00338d" class="ellipse" title="{{ engagementDetail.engagementManagerEmailAddress  }}">
                                <a href="mailto:{{ engagementDetail.engagementManagerEmailAddress }}"
                                  style="color: #00338d; text-decoration: none;">
                                  {{ engagementDetail.engagementManagerEmailAddress }}
                                </a>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </kendo-card-body>
                    </kendo-card>
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Activity Stream</h3>
                        </div>
                      </kendo-card-header>
                      @if (engagementDetail?.activityStream) {
                        <kendo-card-body class="k-custom-card-body k-card-body">
                          <kendo-timeline [events]="engagementDetail?.activityStream"
                            [collapsibleEvents]="false"
                            [alterMode]="false">
                          </kendo-timeline>
                        </kendo-card-body>
                      }
                    </kendo-card>
                    @if (((isApprovalUser && requestStatus === RequestStatusEnum.Pending) || (!isApprovalUser && requestStatus !== RequestStatusEnum.Completed && requestStatus !== RequestStatusEnum.Rejected))) {
                      <div>
                        <kendo-label text="Comments " style="color: black">
                          <span style="color: #757575"><i>(Optional)</i></span>
                        </kendo-label>
                        @if (isApprovalUser) {
                          <kendo-textarea placeholder="Comments"
                            formControlName="ApprovalUserComment"
                            fillMode="none"
                            class="custom-textarea"
                            [rows]="3"
                          resizable="vertical"  [maxlength]="256"></kendo-textarea>
                        }
                        @if (!isApprovalUser) {
                          <kendo-textarea placeholder="Comments"
                            formControlName="SupportUserComment"
                            fillMode="none"
                            class="custom-textarea"
                            [rows]="3"
                          resizable="vertical"  [maxlength]="256"></kendo-textarea>
                        }
                      </div>
                    }
                  </div>
                </form>
              }
              <div>
                @if (message !== '') {
                  <h4 style="color:red">{{ message }}</h4>
                }
              </div>
            </div>
          }
          @if (!isDisplayloader && isApprovalUser) {
            <div class="form-buttons">
              <button kendoButton type="button" (click)="approveEngagementRequest()" class="request-button" [disabled]="requestStatus !== RequestStatusEnum.Pending" themeColor="none">APPROVE</button>
              <button kendoButton type="button" (click)="denyEngagementRequest()" style="width: 100%; background-color: orange; font-weight: 600" [disabled]="requestStatus !== RequestStatusEnum.Pending" themeColor="none">DENY</button>
              <button kendoButton type="button" (click)="cancelEngagementRequest()" style="width: 100%;margin-left: 10px;color: gray;font-weight: 600;">REVIEW LATER</button>
            </div>
          }
          @if (!isDisplayloader && !isApprovalUser) {
            <div class="form-buttons">
              <button kendoButton type="button" (click)="addEngagementRequest()" [disabled]="!requestEngagementRequestForm.valid  || (requestStatus === RequestStatusEnum.Completed  || requestStatus === RequestStatusEnum.Rejected)" class="request-button">ADD</button>
              <button kendoButton type="button" (click)="cancelEngagementRequest()" class="w-100">CANCEL</button>
            </div>
          }
        </div>
      </div>
    </kendo-popup>
  }
</div>

@if (openRequestEngagementPopup) {
  <div class="k-popup-backdrop"></div>
}
